<template>
  <div class="app">
    <div class="content">
      <div class="radio-licenses">
        <div
          class="option"
          :class="{ active: state.selectModel == 'ballet' }"
          @click="state.selectModel = 'ballet'"
        >
          Ballet
        </div>
        <div
          class="option"
          :class="{ active: state.selectModel == 'bath' }"
          @click="state.selectModel = 'bath'"
        >
          Bath
        </div>
      </div>
      <div class="model-wrap">
        <model-viewer
          alt="Neil Armstrong's Spacesuit from the Smithsonian Digitization Programs Office and National Air and Space Museum"
          :src="`/img/${state.selectModel}.glb`"
          ar
          :style="`width: ${
            commonStore.isMobile ? 'calc(90vw - 90px)' : '700px'
          }; height: ${
            commonStore.isMobile ? 'calc(90vw - 90px)' : '700px'
          }; max-width: 700px; max-height: 700px`"
          class="model"
          shadow-intensity="1"
          orientation="0 0 20deg"
          camera-controls
          touch-action="pan-y"
        ></model-viewer>
        <img src="/img/logo.svg" />
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, reactive } from "vue";

  import { useCommonStore } from "@/store/common.store";

  export default defineComponent({
    mounted() {
      window.addEventListener("resize", () => {
        this.commonStore.$patch({ windowWidth: window.innerWidth });
      });
    },

    unmounted() {
      window.removeEventListener("resize");
    },

    setup() {
      const commonStore = useCommonStore();
      const state = reactive({
        selectModel: "ballet",
      });

      return { state, commonStore };
    },
  });
</script>

<style lang="scss">
  * {
    margin: 0;
    padding: 0;
    overflow: hidden !important;
  }

  .model-wrap {
    position: relative;
    width: fit-content;
    height: fit-content;
    margin: 30px auto;
    border-radius: 20px;
    box-shadow: 0px 0px 20px -6px rgb(0 0 0 / 75%);

    img {
      position: absolute;
      height: 35px;
      bottom: 15px;
      right: 70px;
      z-index: -1;
    }
  }

  .app {
    padding: 50px;
  }

  .content {
    height: 100vh;
  }

  .radio-licenses {
    width: fit-content;
    display: flex;
    margin: 0 auto;
    border: 1px solid rgba(0, 0, 255, 0.05);
    border-radius: 32px;
    padding: 4px;

    .option {
      width: 180px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      cursor: pointer;
    }

    .option.active {
      background: #f0f2f5;
      border-radius: 16px;
    }
  }

  @media (max-width: 969px) {
    .app {
      padding: 20px;

      .radio-licenses {
        .option {
          width: fit-content;
          padding: 0 20px;
        }
      }

      .model-wrap {
        img {
          height: calc(100vw / 20);
        }
      }
    }
  }
</style>
